<template>
  <v-app id="inspire">
    <v-main>
      <v-container fluid>
        <v-layout align-center justify-center>
          <v-flex xs12 sm8 md4>
            <v-row>
              <v-col class="d-flex justify-center">
                <img
                  src="@/assets/logo.png"
                  class="d-flex justify-center"
                  width="180"
                />
              </v-col>
            </v-row>
            <v-card class="elevation-12">
              <v-toolbar dark>
                <v-toolbar-title> Entrar no Sistema </v-toolbar-title>
              </v-toolbar>
              <v-form>
                <v-card-text>
                  <v-alert color="red darken-2" dark v-model="alert">
                    <template v-slot:close>
                      <v-icon @click="() => (alert = false)">
                        mdi-close
                      </v-icon>
                    </template>
                    <label>{{ error }}</label>
                  </v-alert>
                  <v-text-field
                    prepend-icon="mdi-account"
                    name="login"
                    v-model="email"
                    label="Email"
                    type="text"
                  ></v-text-field>
                  <v-text-field
                    id="password"
                    v-model="password"
                    prepend-icon="mdi-lock"
                    name="password"
                    label="Senha"
                    type="password"
                  ></v-text-field>
                </v-card-text>
                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn color="primary" @click.prevent="validarLogin()"
                    >Entrar</v-btn
                  >
                </v-card-actions>
              </v-form>
            </v-card>
          </v-flex>
        </v-layout>
      </v-container>
    </v-main>
  </v-app>
</template>

<script>
import * as API from "@/api/requests/LoginRequest";

export default {
  name: "Login",
  data: () => ({
    email: "",
    password: "",
    error: "",
    alert: false,
  }),
  props: {
    source: String,
  },
  methods: {
    async validarLogin() {
      if (this.email == "" || this.password == "") {
        this.error = "Preencha o Email e Senha para poder Entrar";
        this.alert = true;
        return false;
      }

      try {
        let res = await API.validate({
          email: this.email,
          password: this.password,
        });
        if (res.error) {
          throw new Error(res.error);
        }
        if (res.user.type === "provider" || res.user.type === "franchise") {
          if (res.user.companies.length === 0) {
            this.showAlertCompany();
            return false;
          } else {
            this.$router.push({ name: "ChooseCompany" });
          }
        } else {
          this.$router.push({ name: "Home" });
        }
      } catch (error) {
        // console.log(error);
        let errorTxt = "Email ou senha incorretos";
        // if (error.response.status === 401) {
        //   errorTxt =
        //     "Dados inválidos, verifique email ou senha e tente novamente";
        // }
        this.error = errorTxt;
        this.alert = true;
      }
      return false;

      // this.$router.push({ name: "Home" });
    },
    showAlertCompany() {
      this.error =
        "Nenhuma empresa vinculada a essa usuário, entre em contato com o suporte";
      this.alert = true;
    },
  },
};
</script>

<style></style>
